import { defaultEppIcos, defaultEpp, dataInitialEpps } from "./state";

/**
 * Mutación para cargar la información de epp del sistema al formulario.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} jsonEpp contiene la información de los epp del sistema.
 */
export function cargarJsonEpp(state, jsonEpp) {

    state.selectedEpp.ocular = [];
    state.selectedEpp.cutanea = [];
    state.selectedEpp.respiratoria = [];
    state.selectedEpp.calzado = [];
    state.selectedEpp.ropa = [];


    for (var i = 0; i < jsonEpp.ocular.length; i++) {
        state.selectedEpp.ocular.push({ id: jsonEpp.ocular[i].id, descripcion: jsonEpp.ocular[i].descripcion, icono_estado: jsonEpp.ocular[i].icono_estado, icono_aplica: jsonEpp.ocular[i].icono_aplica });
    }

    for (var i = 0; i < jsonEpp.cutanea.length; i++) {
        state.selectedEpp.cutanea.push({ id: jsonEpp.cutanea[i].id, descripcion: jsonEpp.cutanea[i].descripcion, icono_estado: jsonEpp.cutanea[i].icono_estado, icono_aplica: jsonEpp.cutanea[i].icono_aplica });
    }

    for (var i = 0; i < jsonEpp.respiratoria.length; i++) {
        state.selectedEpp.respiratoria.push({ id: jsonEpp.respiratoria[i].id, descripcion: jsonEpp.respiratoria[i].descripcion, icono_estado: jsonEpp.respiratoria[i].icono_estado, icono_aplica: jsonEpp.respiratoria[i].icono_aplica });
    }

    for (var i = 0; i < jsonEpp.calzado.length; i++) {
        state.selectedEpp.calzado.push({ id: jsonEpp.calzado[i].id, descripcion: jsonEpp.calzado[i].descripcion, icono_estado: jsonEpp.calzado[i].icono_estado, icono_aplica: jsonEpp.calzado[i].icono_aplica });
    }

    for (var i = 0; i < jsonEpp.ropa.length; i++) {
        state.selectedEpp.ropa.push({ id: jsonEpp.ropa[i].id, descripcion: jsonEpp.ropa[i].descripcion, icono_estado: jsonEpp.ropa[i].icono_estado, icono_aplica: jsonEpp.ropa[i].icono_aplica });
    }

}

/**
 * Mutación para cargar la información de los epp de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} Epp contiene la informacion de epp del producto químico.
 */
export function cargarEpp(state, Epp) {

    state.selectedEpp.proteccion_ocular = Epp.ocular;
    state.selectedEpp.proteccion_cutanea = Epp.cutanea;
    state.selectedEpp.proteccion_respiratoria = Epp.respiratoria;
    state.selectedEpp.proteccion_calzado = Epp.calzado;
    state.selectedEpp.proteccion_ropa = Epp.ropa;
}

/**
 * Mutación para limpiar el formulario de creación de epps
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
export function limpiarCreacionEpp(state) {
    state.selectedEpp.descripcion = '';
    state.selectedEpp.tipo = '';
}

/**
 * Mutación para editar
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
 export function setSelectedEpp(state, selectedEpp) {
    state.selectedEpp.descripcion = selectedEpp.descripcion;
    state.selectedEpp.tipo = selectedEpp.tipo;
    state.selectedEpp.id_epp = selectedEpp.id;
}

/**
 * Mutación para cambiar de página
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
export function setPage(state, page) {
    state.filtro.page = page;
}

/**
 * Mutación para cambiar registros por página
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
export function setPerPage(state, perPage) {
    state.filtro.perPage = perPage;
}

export function limpiarBusqueda(state) {
    state.filtro.buscarDescripcion = '';
    state.filtro.buscarTipo = '';
}

/**
 * Mutación para limpiar el listado de epps personalizados por cada producto.
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
export function limpiarListaEpps(state) {
    state.selectedEpp.lista = [];
}

/**
 * Mutación para cargar la información de los epp descritos de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} eppDescritos contiene la informacion de los epp descritos de un producto químico.
 */
export function cargarEppDescritos(state, eppDescritos) {
    state.selectedEpp.lista = [];
    let tipos = ['Protección Ocular', 'Protección Cutanea', 'Protección Respiratoria', 'Botas/Calzado', 'Traje/Ropa Protectora'];
    eppDescritos.data.data.forEach(element => {
        element.tipo_descripcion = tipos[element.tipo-1];
    });
    state.selectedEpp.lista = eppDescritos.data.data;
    state.filtro.total = eppDescritos.data.total;
}

/**
 * Mutación para cargar la información de los epp icos de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} eppIcos contiene la informacion de los epp icos de un producto químico.
 */
export function cargarEppIcos(state, eppIcos) {
    state.selectedEppIcos.layer_ocular = eppIcos.ocular[0];
    state.selectedEppIcos.layer_cutanea = eppIcos.cutanea[0];
    state.selectedEppIcos.layer_respiratoria = eppIcos.respiratoria[0];
    state.selectedEppIcos.layer_calzado = eppIcos.calzado[0];
    state.selectedEppIcos.layer_ropa = eppIcos.ropa[0];
}

/**
 * Mutación para limpiar los iconos de los epp's.
 *
 * @param {*} state contiene la información de las variables del formulario.
 */
export function setDefaultEppIcos(state) {
    Object.assign(state.selectedEppIcos, defaultEppIcos())
}

/**
 * Mutación para cargar la información de los epp icos de un producto químico de una empresa.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} eppIcos contiene la informacion de los epp icos de un producto químico de una empresa.
 */
export function cargarEppIcosEmpre(state, eppIcos) {
    state.iconos = [];
    state.selectedEppIcos.layer_ocular = eppIcos.ocular[0];
    state.selectedEppIcos.layer_cutanea = eppIcos.cutanea[0];
    state.selectedEppIcos.layer_respiratoria = eppIcos.respiratoria[0];
    state.selectedEppIcos.layer_calzado = eppIcos.calzado[0];
    state.selectedEppIcos.layer_ropa = eppIcos.ropa[0];

    //ocular
    if (state.selectedEppIcos.layer_ocular.ocular1) {
        state.iconos.push(state.ocular_pics[0]);
    } else if (state.selectedEppIcos.layer_ocular.ocular2) {
        state.iconos.push(state.ocular_pics[1]);
    } else if (state.selectedEppIcos.layer_ocular.ocular3) {
        state.iconos.push(state.ocular_pics[2]);
    }

    //cutaneo
    if (state.selectedEppIcos.layer_cutanea.cutanea1) {
        state.iconos.push(state.guantes_pics[0]);
    }

    //respiratoria
    if (state.selectedEppIcos.layer_respiratoria.respiratoria1) {
        state.iconos.push(state.respiratoria_pics[0]);
    } else if (state.selectedEppIcos.layer_respiratoria.respiratoria2) {
        state.iconos.push(state.respiratoria_pics[1]);
    } else if (state.selectedEppIcos.layer_respiratoria.respiratoria3) {
        state.iconos.push(state.respiratoria_pics[2]);
    } else if (state.selectedEppIcos.layer_respiratoria.respiratoria4) {
        state.iconos.push(state.respiratoria_pics[3]);
    }

    //cutaneo
    if (state.selectedEppIcos.layer_calzado.calzado1) {
        state.iconos.push(state.botas_pics[0]);
    }

    //ropa
    if (state.selectedEppIcos.layer_ropa.ropa1) {
        state.iconos.push(state.trajes_pics[0]);
    } else if (state.selectedEppIcos.layer_ropa.ropa2) {
        state.iconos.push(state.trajes_pics[1]);
    }

}

/**
 * Mutación para cargar la información de los epp de un producto químico de una empresa.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} Epp contiene la informacion de los epp de un producto químico de una empresa.
 */
export function cargarEppEmpresa(state, Epp) {

    state.lista_ocular = Epp.ocular;
    state.lista_cutanea = Epp.cutanea;
    state.lista_respiratoria = Epp.respiratoria;
    state.lista_calzado = Epp.calzado;
    state.lista_ropa = Epp.ropa;
}

/**
 * Mutación para limpiar los iconos de epp de un producto.
 *
 * @param {*} state
 */
export function limpiaIconos(state) {
    state.iconos = [];

}

/**
 * Mutación para limpiar el array que aparece en el select de agregar otro epp
 *
 * @param {*} state
 */

export function limpiarTiposEppModal(state){
    state.tipos_epp_modal = [];
}


/**
 * Mutación para agregar los tipos de epp en el select de agregar otro epp cuando se entra a la interfaz de epp
 *
 *
 */
export function setTiposEppModal(state, data){
    state.tipos_epp_modal.push(data);
}

/**
 * Mutación para validar si mostrar el mensaje de epp eliminado o no
 *
 *
 */
export function setMensajeEliminado(state, data){
    state.mensajeEliminado = data;
}

/**
 * Mutación para resetear los epps.
 *
 */
export function setDefaultEpps(state) {
    state.selectedEpp = defaultEpp();
    state.selectedEppIcos = defaultEppIcos()
}


/**
 * Resetear los datos de Epps de IA.
 * @param Object state 
 */
export function resetEppsReadFdsIA(state) {
    state.eppsReadFdsIA = dataInitialEpps();
}

/**
 * Establecer los datos de epps cargados con IA.
 * 
 * @param Object state 
 * @param Object nextState 
 */
export function setEppsReadFdsIA(state, nextState) {
    state.eppsReadFdsIA = nextState;
}

/**
 * Establecer los datos de epps a su estado básico.
 * 
 * @param Object state 
 */
export function resetSelectedEppIcos(state) {
    try {
        state.selectedEppIcos.layer_ocular.ocular1 = false
        state.selectedEppIcos.layer_ocular.ocular2 = false
        state.selectedEppIcos.layer_ocular.ocular3 = false
        state.selectedEppIcos.layer_cutanea.cutanea1 = false
        state.selectedEppIcos.layer_respiratoria.respiratoria1 = false
        state.selectedEppIcos.layer_respiratoria.respiratoria2 = false
        state.selectedEppIcos.layer_respiratoria.respiratoria3 = false
        state.selectedEppIcos.layer_respiratoria.respiratoria4 = false
        state.selectedEppIcos.layer_calzado.calzado1 = false
        state.selectedEppIcos.layer_ropa.ropa1 = false
        state.selectedEppIcos.layer_ropa.ropa1 = false
    } catch (e) {
        setDefaultEppIcos();
    }
}

